import React, { Component } from "react"
import styled from "styled-components"
import ScreensizeProvider from "../components/ScreensizeProvider"
import Footer from "./Footer"
import Nav from "./Nav"

const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  padding-top: 100px;

  @media (max-width: 768px) {
    padding-top: 50px;
  }
`

export default function Layout({ children, location }) {
  return (
    <div>
      <Container>
        <Nav location={location} />
        <ScreensizeProvider>{children()}</ScreensizeProvider>
        <Footer />
      </Container>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/layouts/index.js